import { SpotBellBaseIcon } from '@tableau/icons/SpotBellBaseIcon';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { NotificationCenterStyles } from '../styles/notificationCenterStyles';

export function NotificationLoadFail() {
  return (
    <div className='loadingNotificationFailed' style={NotificationCenterStyles.notificationEmptyList}>
      <div className='bellImg'> <SpotBellBaseIcon size={80} alt='' /></div>
      <div className='errorMessage' style={NotificationCenterStyles.notificationEmptyTitle}> {Messages.userNotificationLoadError()} </div>
      <div className='tryAgainLater' style={NotificationCenterStyles.notificationSecondTitle}> {Messages.userNotificationTryAgainLater()} </div>
    </div>
  );
}
